import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {
  fetchDevice,
  fetchDevices,
} from "../../actions/callrecorder/devicesActions";

export interface DeviceInterface {
  url: string;

  id: number;
  user_id: number;
  xdid: number | null;

  bundle: string;
  vendor: string;
  advertise: string;

  reg_bundle: string | null;
  reg_vendor: string | null;
  reg_advertise: string | null;
  reg_user_id: number | null;

  notify_token: string | null;
  timezone: number | null;
  country_code: string | null;
  language: string | null;

  sign_in_count: number;
  current_sign_in_at: string | null;
  last_sign_in_at: string | null;
  current_sign_in_ip: string | null;
  last_sign_in_ip: string | null;
  reg_sign_in_ip: string | null;

  is_deleted: boolean;

  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
};

const adaptor = createEntityAdapter<DeviceInterface>();

const slice = createSlice({
  name: 'devices',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchDevices.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchDevices.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.devices;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchDevices.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchDevice.fulfilled, (state, action) => {
        const device = Object.values(action.payload.device)[0];
        state.entities[device.id] = device;
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectDeviceById,
  selectIds: selectDeviceIds,
  selectEntities: selectDeviceEntities,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.devices);
